import StatusCodes from 'http-status-codes'
import { rest } from 'msw'

import { type Comment } from '@webapp/models/Comment'
import { type IApiV3Response } from '@webapp/services/api'
import { CommentMock } from '@webapp/tests/mocks'
import { type CreateCommentSchema } from '../CommentsAPI'

export const createCommentStub = (response?: Comment) => {
  return rest.post<CreateCommentSchema, IApiV3Response<Comment>>(
    '/api/v3/comments/',
    (req, res, ctx) => {
      return res(
        ctx.status(StatusCodes.CREATED),
        ctx.json({
          data: response ?? CommentMock.build(),
        })
      )
    }
  )
}
